import { compressPhoto } from '../element3D/designExport.jsx';
import { createDesign, uploadDesignFiles } from './designsApi.jsx';

// «انتشار» در صفحه‌ی «ساخت فایل جدید»: فایل‌هایی که با «پایان طراحی» ساخته شده‌اند (نقشه، مدلِ رندرشده، نقشه‌ی نور،
// عکس‌ها، فیلم) — همان ارسالِ تکه‌تکه و قابلِ ادامه‌ی قبلی. prepared: { meta, files } (شناسه‌ی طرحِ ساخته‌شده روی
// خودش می‌ماند تا اگر وسطِ کار قطع شد، «تلاشِ دوباره» از همان‌جا ادامه دهد). onProgress(sent, total)
export async function publishDesign(prepared, title, onProgress) {
  const { meta, files } = prepared;
  if (!prepared.designId) {
    const created = await createDesign({ ...meta, title }, files);
    prepared.designId = created.id;
  }
  try {
    const { design } = await uploadDesignFiles(prepared.designId, files, onProgress);
    return design;
  } catch (e) {
    // طرحِ خراب/منقضی: دفعه‌ی بعد از اول ساخته شود
    if (['not-found', 'not-uploading', 'bad-model', 'bad-image', 'bad-plan', 'bad-file'].includes(e.code)) prepared.designId = null;
    throw e;
  }
}

// فیلمِ تبلیغاتیِ آماده‌شده (برای پخش در صفحه‌ی آگهی، قبل از انتشار)
export function preparedFilm(prepared) {
  const files = (prepared && prepared.files) || {};
  return files['film.mp4'] || files['film.webm'] || null;
}

// ---------- آگهیِ بدونِ پلانِ سه‌بعدی ----------
// فقط اطلاعات و عکس‌های آگهی + یک تصویرِ پیش‌فرض (thumb.jpg) که روشن می‌گوید «این آگهی پلانِ سه‌بعدی ندارد»
// (سرور: renderSource 'none' — مدل/نقشه‌ی نور ندارد؛ صفحه‌ی آگهی دکمه‌ی «ورود به خانه» را غیرفعال نشان می‌دهد)
async function noPlanThumb(formData) {
  const W = 1080;
  const H = 1350;
  const c = document.createElement('canvas');
  c.width = W;
  c.height = H;
  const g = c.getContext('2d');
  const bg = g.createLinearGradient(0, 0, 0, H);
  bg.addColorStop(0, '#eef1f5');
  bg.addColorStop(1, '#dde3ea');
  g.fillStyle = bg;
  g.fillRect(0, 0, W, H);
  // خانه‌ی خط‌چین (یعنی «نقشه ندارد»)
  g.save();
  g.translate(W / 2, H * 0.4);
  g.strokeStyle = '#8a96a6';
  g.lineWidth = 14;
  g.lineJoin = 'round';
  g.lineCap = 'round';
  g.setLineDash([34, 26]);
  g.beginPath();
  g.moveTo(-210, -10);
  g.lineTo(0, -200);
  g.lineTo(210, -10);
  g.moveTo(-160, -50);
  g.lineTo(-160, 200);
  g.lineTo(160, 200);
  g.lineTo(160, -50);
  g.stroke();
  g.setLineDash([]);
  g.strokeRect(-45, 70, 90, 130);
  g.restore();
  try {
    if (document.fonts && document.fonts.load) await document.fonts.load('700 60px Vazirmatn');
  } catch (e) {
    /* بدونِ فونتِ وزیر هم کار می‌کند */
  }
  g.direction = 'rtl';
  g.textAlign = 'center';
  g.fillStyle = '#3d4654';
  g.font = '700 64px Vazirmatn, Tahoma, sans-serif';
  g.fillText('بدونِ پلانِ سه‌بعدی', W / 2, H * 0.66);
  g.fillStyle = '#6b7685';
  g.font = '400 40px Vazirmatn, Tahoma, sans-serif';
  g.fillText('فقط اطلاعات و عکس‌های آگهی', W / 2, H * 0.66 + 76);
  const area = Number(formData && formData.area);
  if (area > 0) {
    g.fillStyle = '#8a96a6';
    g.font = '400 36px Vazirmatn, Tahoma, sans-serif';
    g.fillText(`${area.toLocaleString('fa-IR')} متر`, W / 2, H * 0.66 + 150);
  }
  const blob = await new Promise((resolve) => c.toBlob(resolve, 'image/jpeg', 0.86));
  if (!blob) throw new Error('تصویرِ پیش‌فرض ساخته نشد.');
  return blob;
}

export async function prepareListingOnly(formData, editorState) {
  const { photos, ...listing } = formData || {};
  const files = {};
  const list = (photos || []).filter((ph) => ph && ph.url).slice(0, 8);
  let n = 0;
  for (const ph of list) {
    try {
      files[`photo-${n + 1}.jpg`] = await compressPhoto(ph.url);
      n += 1;
    } catch (e) {
      /* عکسی که دیگر در دسترس نیست */
    }
  }
  files['thumb.jpg'] = await noPlanThumb(formData);
  // پلانِ دوبعدیِ نیمه‌کاره (اگر هست) هم کنارش می‌ماند
  if (editorState && editorState.walls && editorState.walls.length) {
    const plan = { version: 1, app: 'khoonero', savedAt: new Date().toISOString(), editor: editorState, scene: null };
    files['plan.json'] = new Blob([JSON.stringify(plan)], { type: 'application/json' });
  }
  return { meta: { renderSource: 'none', listing }, files };
}
